import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { Linkedin } from "lucide-react";

export const advisors = [
  {
    name: "Andrei Oprisan",
    title: "Entrepreneur | CTO",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/andrei.jpeg",
    expertise: "MIT | Agent AI",
    linkedin: "https://www.linkedin.com/in/andreioprisan/",
  },
  {
    name: "Maria Tkacheva",
    title: "Entrepreneur | COO",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/maria.jpeg",
    expertise: "MIT | Seneca Polytechnic",
    linkedin: "https://www.linkedin.com/in/mariatkacheva/",
  },
  {
    name: "Michael A. Celone",
    title: "Attorney | Regulatory Strategy",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/michael.jpeg",
    expertise: "MIT | Harvard Law School",
    linkedin: "https://www.linkedin.com/in/michael-a-celone",
  },
  {
    name: "Tushar Kumar",
    title: "Oncologist | Entrepreneur",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/tushar.jpeg",
    expertise: "MIT | Wayne University School of Medicine",
    linkedin: "https://www.linkedin.com/in/tushar-kumar-md-mba-674a78253/",
  },
  {
    name: "Kyle Watson",
    title: "Cybersecurity Leader | Entrepreneur",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/kyle.jpeg",
    expertise: "Rochester Institute  of Technology",
    linkedin: "https://www.linkedin.com/in/tokylewatson/",
  },
  {
    name: "Shiro Matsuzaki",
    title: "Founder | Serial Intrapreneur",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/shiro.jpeg",
    expertise: "MIT | Waseda University",
    linkedin: "https://www.linkedin.com/in/shiro-matsuzaki-184a52192/",
  },
  {
    name: "Ayo Okeowo",
    title: "Cybersecurity Leader",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/ayo.jpeg",
    expertise: "MIT | University of Oxford",
    linkedin: "https://www.linkedin.com/in/okeowo/",
  },
  {
    name: "Steven Smith",
    title: "General Counsel | COO",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/steven.jpeg",
    expertise: "MIT | Boston College Law School",
    linkedin: "https://www.linkedin.com/in/steven-smith-331b0811/",
  },
  {
    name: "Chris Kenny, MD",
    title: "Chief Medical Officer",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/chris.jpeg",
    expertise: "MIT | Boston University School of Medicine",
    linkedin: "https://www.linkedin.com/in/chris-kenney-md-mba-faan-867751a/",
  },
];

export default function AdvisorsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="advisors"
      className="py-10 md:py-20 bg-gray-50 w-full"
      ref={ref}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Our Support
          </h2>
          <p className="text-xl text-gray-600 font-medium max-w-2xl mx-auto">
            Industry leaders guiding our mission to transform global education.
          </p>
        </motion.div>

        <div className="flex flex-wrap justify-center items-stretch gap-8">
          {advisors.map((member, index) => (
            <motion.div
              key={member.name}
              className="group bg-white rounded-2xl p-4 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 w-full md:w-[30%]"
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
            >
              <div className="text-center">
                <div className="relative mb-6">
                  <img
                    src={member.image}
                    alt={member.name}
                    width={120}
                    height={120}
                    className="rounded-full mx-auto shadow-lg"
                  />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {member.name}
                </h3>
                <p className="text-[#80E280] font-bold text-base mb-2">
                  {member.title}
                </p>
                <p className="text-gray-600 text-base leading-relaxed mb-4">
                  {member.expertise}
                </p>
                <motion.a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-10 h-10 bg-gray-100 rounded-full hover:bg-[#80E280] hover:text-white transition-colors duration-200 opacity-0 group-hover:opacity-100"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <Linkedin size={18} />
                </motion.a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
